import script from "./add-one-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./add-one-dialog.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__